<template>
    <div class="index" :class="{cookieNotificationSpace: !isCookieAccepted}">
        <div class="index__background">
            <NavBar />
            <Welcome />
            <Company />
            <Services />
            <Partners />
            <Technologies />
        </div>
        <Contact />
        <FooterBar />
        <Cookie v-if="$cookie.get('c00kie') != 'Informed!'" @cookieAccepted="isCookieAccepted = true"/>
    </div>
</template>

<script>

    import NavBar from '@/components/NavBar'
    import Welcome from '@/components/Welcome'
    import Company from '@/components/Company'
    import Services from '@/components/Services'
    import Partners from '@/components/Partners'
    import Technologies from '@/components/Technologies'
    import Contact from '@/components/Contact'
    import FooterBar from '@/components/FooterBar'
    import Cookie from '@/components/Cookie'

    export default {
        name: 'index',

        data() {
            return {
                isCookieAccepted: false,
            }
        },

        mounted() {
            (this.$cookie.get('c00kie') == 'Informed!') ? this.isCookieAccepted = true : this.isCookieAccepted = false
        },

        components: {
            NavBar,
            Welcome,
            Company,
            Services,
            Partners,
            Technologies,
            Contact,
            FooterBar,
            Cookie
        }
    }

</script>

<style lang="scss" scoped>
    .index {
        &__background {
            background-image: url("../assets/background.jpg");
            background-position: center; 
            background-repeat: repeat-y; 
            background-size: cover; 
            -webkit-animation: move 5s infinite; /* Safari 4.0 - 8.0 */
            animation: move 60s infinite;
            animation-timing-function: linear !important;
        }
    }

    @-webkit-keyframes move {
        0%   {background-position-y: 0px;}
        25%  {background-position-y: 250px;}
        50%  {background-position-y: 0px;}
        75% {background-position-y: 250px;}
        100% {background-position-y: 0px;}
    }

    /* Standard syntax */
    @keyframes move {
        0%   {background-position-y: 0px;}
        25%  {background-position-y: 250px;}
        50%  {background-position-y: 0px;}
        75% {background-position-y: 250px;}
        100% {background-position-y: 0px;}
    }

	@media all and (max-width: 1170px) {
        .index__background {
            animation: initial;
            background-image: url("../assets/background-mobile.jpg");
        }
    }

    @media all and (max-width: 830px) {

        .cookieNotificationSpace {
            margin-bottom: 65px;
        }
    }
    @media all and (max-width: 380px) {
        .cookieNotificationSpace {
            margin-bottom: 75px;
        }
    }
</style>